import React, { useState } from "react";

import { servicePick, toEndDayTime, toStartDayTime, removeTZFromDate, compareObjects } from "utils";
import { FULL_REPORT_GROUP_METHOD, SMS_FULL_REPORT_GROUP_METHOD } from "const/apiMethods";
import { DESC_SORT } from "const";
import { usePrevious, useWindowWidth } from "hooks";

import FullReportFilters from "./FullReportFilters";
import FullReportTable from "./FullReportTable";
import PanelLayout from "components/base/PanelLayout";
import PageHeader from "components/base/PageHeader";
import ExportCsv from "components/ExportCsv";
import { FlexboxGrid } from "rsuite";


const FullReportPage = ({
    data,
    count,
    loading,
    page,

    service,
    globalSettings,

    reasonList,
    dialerList,
    countryList,
    supplierList,
    originatorList,
    servicePlanList,
    accountManagerList,
    subdestinationList,
    accountManagerBilList,

    getReferencesForReports,

    getAccountManagersBillingList,
    getAccountManagersDropdownList,

    getData
}) => {
    const today = new Date();

    const defaultFilter = {
        range: [toStartDayTime(today), toEndDayTime(today)],
        group_checkbox: [],
        show_reliable: true,
        show_not_reliable: true,
        ...(!service ? { only_my_account: true } : {})
    };

    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < 767;

    const defaultSortColumn = "count";
    const defaultSort = { column: defaultSortColumn, type: "desc" };
    const [sort, setSort] = useState(defaultSort);

    const [filters, setFilters] = useState(defaultFilter);
    const [preFilters, setPreFilters] = useState(defaultFilter);

    const methodExport = servicePick(service, FULL_REPORT_GROUP_METHOD, SMS_FULL_REPORT_GROUP_METHOD);

    const exportFilter = { ...preFilters };

    if (exportFilter.range && exportFilter.range.length) {
        exportFilter["start_date"] = removeTZFromDate(toStartDayTime(exportFilter.range[0]));
        exportFilter["end_date"] = removeTZFromDate(toEndDayTime(exportFilter.range[1]));

        delete exportFilter.range;
    }

    const exportGroupCheckbox = exportFilter?.group_checkbox || [];

    if (exportGroupCheckbox.length) {
        delete exportFilter.group_checkbox;
    }

    const onApplyFilters = (value) => {
        setFilters(value);

        if (
            !compareObjects(sort, defaultSort) &&
            (!!value.group_checkbox?.length &&
                !value.group_checkbox.includes(sort.column) ||
                !value.group_checkbox?.length)
        ) {
            setSort(defaultSort);
        }
    };

    return (
        <PanelLayout>
            <PageHeader title="Full MDR Report" showService={false}>
                <ExportCsv
                    method={methodExport}
                    params={{
                        filter: exportFilter,
                        group_checkbox: exportGroupCheckbox,
                        sort1: sort?.column,
                        sort1_desc: sort?.type === DESC_SORT
                    }}
                    title="Export CSV"
                    fileName="full_report.csv"
                    style={{ position: "relative", right: 15 }}
                />
            </PageHeader>

            <FlexboxGrid>
                <FlexboxGrid.Item colspan={24}>
                    <FullReportFilters
                        sort={sort}
                        preFilters={preFilters}
                        currentFilters={filters}
                        defaultFilters={defaultFilter}
                        globalSettings={globalSettings}
                        defaultSort={defaultSort}
                        isMobile={isMobile}

                        {...{
                            reasonList,
                            dialerList,
                            countryList,
                            supplierList,
                            originatorList,
                            servicePlanList,
                            accountManagerList,
                            subdestinationList,
                            accountManagerBilList,

                            getReferencesForReports,

                            getAccountManagersBillingList,
                            getAccountManagersDropdownList
                        }}

                        setSort={setSort}
                        setPreFilters={setPreFilters}
                        onApplyFilters={onApplyFilters}
                    />
                </FlexboxGrid.Item>
            </FlexboxGrid>
            <FullReportTable
                data={data}
                count={count}
                loading={loading}
                page={page}
                sort={sort}
                filters={filters}
                setSort={setSort}
                getData={getData}
            />
        </PanelLayout>
    );
};

export default FullReportPage;
